import type { Scene } from "@babylonjs/core/scene";
import type { Mesh } from "@babylonjs/core/Meshes/mesh";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { PBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import type { PhysicsSystem } from "../../systems/PhysicsSystem";
import {
  CONSERVATORY_GROUND, OVERGROWN_CONSERVATORY_PLATFORMS,
  platformDepth, platformHeight,
} from "../layouts";

export interface ConservatorySurfaces { ground: Mesh; platforms: Mesh[] }

/** Same shipping bodies, with opaque art-failure surfaces at their actual tops. */
export function createConservatorySurfaces(scene: Scene, physics: PhysicsSystem): ConservatorySurfaces {
  const g = CONSERVATORY_GROUND;
  const ground = physics.createPlatform(g.name, g.w, g.h, g.d, new Vector3(g.x, g.y, 0));
  const platforms = OVERGROWN_CONSERVATORY_PLATFORMS.platforms.map(p =>
    physics.createPlatform(p.name, p.w, platformHeight(p), platformDepth(p), new Vector3(p.x, p.y, 0)),
  );
  const floor = new PBRMaterial("conservatoryFallbackFloorMat", scene);
  floor.albedoColor = new Color3(0.18, 0.14, 0.11);
  floor.metallic = 0; floor.roughness = 0.95;
  const landing = new PBRMaterial("conservatoryFallbackLandingMat", scene);
  landing.albedoColor = new Color3(0.19, 0.25, 0.20);
  landing.metallic = 0.15; landing.roughness = 0.8;
  for (const surface of [ground, ...platforms]) {
    // createPlatform owns these fresh fallback materials, never cached assets.
    surface.material?.dispose();
    surface.material = surface === ground ? floor : landing;
    surface.isVisible = true;
    surface.receiveShadows = true;
  }
  return { ground, platforms };
}
